export default __webpack_public_path__ + "static/media/Sarthak Gupta.8de63f1e.jpeg";